import { learningServiceRequest, skip } from "./utils";

/**
 * Converts an array of equivalent objects from snake_case to camelCase properties.
 * @param {Array} equivalentsArray - Array of equivalent objects to convert
 * @returns {Array} - Array of converted equivalent objects
 */
export const convertClassEquivalents = (equivalentsArray) => {
  if (!equivalentsArray || !Array.isArray(equivalentsArray)) {
    return [];
  }
  return equivalentsArray
    .map((equivalent) => {
      if (!equivalent) return null;
      const {
        approval_date: approvalDate = "",
        class_id: classId = "",
        comments = "",
        expiration_date: expirationDate = "",
        home_class_id: homeClassId = "",
        home_class_title: homeClassTitle = "",
        home_entity_id: homeEntityId = "",
        id = "",
      } = equivalent;

      return {
        approvalDate,
        classId,
        comments,
        expirationDate,
        homeClassId,
        homeClassTitle,
        homeEntityId,
        id,
      };
    })
    .filter((item) => item !== null);
};

const mapToApproveCoursesTable = (items) => {
  const cityAndCountry = (cityCountryArray) => cityCountryArray.filter((item) => item !== "").join(", ");
  const rank = (cosine) => Number(cosine.toPrecision(2)) * 100;
  const classTitleAndInstitution = (classAndHomeInstitutionArray) =>
    classAndHomeInstitutionArray.filter((item) => item !== "").join(" - ");
  return items.map((item) => {
    const city = item?.host_institution?.shipping_address_city || "";
    const country = item?.host_institution?.country?.name || "";
    const cosineSimilarity = item?.cosine_similarity || "";
    const hostInstitutionName = item?.host_institution?.name || "";
    const title = item?.title || "";
    return {
      classId: item?.id || "",
      description: item?.description || "",
      credits: item?.host_institution_credit_amount || "",
      syllabus: item?.host_institution_url_syllabus || "",
      languageOfInstruction: item?.language_of_instruction?.value || "",
      classTitleAndHomeInstitution: classTitleAndInstitution([title, hostInstitutionName]),
      recommendedUsCreditAmount: item?.recommended_us_credit_amount,

      city,
      country,
      title,
      hostInstitutionName,

      cityAndCountry: cityAndCountry([city, country]),
      courseLevel: item?.level || [],
      equivalents: item?.equivalents ? convertClassEquivalents(item.equivalents) : [],
      cosineSimilarity,
      rank: rank(cosineSimilarity),
    };
  });
};

const inferenceCoursesService = {
  async getCourses(limit, page, home_entity_id, userInput, filters) {
    const response = await learningServiceRequest({
      method: "post",
      url: "/ci/ci_equivalents/search/",
      params: {
        limit,
        skip: skip(page, limit),
        home_entity_id: home_entity_id,
        cities: filters.cities.map((item) => item.city),
        country_ids: filters.countries.map((item) => item.id),
        host_institution_ids: filters.hostInstitutions.map((item) => item.id),
        language_of_instruction_ids: filters.languagesOfInstruction.map((item) => item.id),
        course_level_ids: filters.courseLevels.map((item) => item.id),
      },
      payload: { input: userInput },
    });

    const { items = [], count } = response?.data?.data || {};
    return { items: mapToApproveCoursesTable(items), count };
  },
};

export default inferenceCoursesService;
